import line from "./img/line.png";
import logo from "./img/logo.png";
import bg from "./img/bg.png";
import { useState } from "react";
export default function Footer() {
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const register = async () => {
    if (email.length !== 0) {
      await fetch("https://sub.monsterra.io/subscriber/subscribe", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mail: email,
          content_id: 1,
          meta: {},
        }),
      });
      setEmail("");
      setMessage("show");
    }
  };
  const social = [
    {
      img: require("./img/twitter.png"),
      sideImg: require("./img/social/twitter.webp"),
      url: "https://twitter.com/Monsterra_P2E",
    },
    {
      img: require("./img/telegram.png"),
      sideImg: require("./img/social/telegram.webp"),
      url: "https://t.me/+Od2MNRoTTVo1MDM1",
    },
    {
      img: require("./img/discord.png"),
      sideImg: require("./img/social/discord.webp"),
      url: "https://discord.gg/fwdNrymG",
    },
    {
      img: require("./img/facebook.png"),
      sideImg: require("./img/social/facebook.webp"),
      url: "https://www.facebook.com/Monsterra-P2E-Game-100591379141319",
    },
    {
      img: require("./img/medium.webp"),
      sideImg: require("./img/social/medium.webp"),
      url: "https://medium.com/@monsterra.io",
    },
    {
      img: require("./img/youtube.png"),
      sideImg: require("./img/social/youtube.webp"),
      url: "https://www.youtube.com/MonsterraNFTGame",
    },
    {
      img: require("./img/tiktok.webp"),
      sideImg: require("./img/social/tiktok.webp"),
      url: "https://www.tiktok.com/@monsterra_nftgame",
    },
  ];
  return (
    <div
      className="bg-center relative text-white text-center bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="fixed top-20 right-0 z-10 hidden md:block">
        <div className="flex gap-1 flex-col">
          {social.map((s: any) => (
            <a href={s.url} target="_blank">
              <img
                src={s.sideImg}
                className="transform hover:scale-125 duration-100"
              />
            </a>
          ))}
        </div>
      </div>
      {message !== "" && (
        <div className="fixed top-0 left-0 w-screen h-screen z-10 bg-black bg-opacity-80">
          <div className="flex justify-center items-center w-full h-full">
            <div className="border-2 border-[#934F00] rounded-md bg-white text-center p-4">
              <p className="text-[#934F00] text-xl">Successfully</p>
              <div className="text-[#934F00] opacity-60 mt-4">
                <p>Thank you for subcribing to our Monsterra Newsletter.</p>
                <p>Stay tuned for more updates!</p>
              </div>
              <div
                onClick={() => {
                  setMessage("");
                }}
                className="mt-8 cursor-pointer bg-[#F1B27A] text-white rounded-md inline-block px-4 py-2"
              >
                Close
              </div>
            </div>
          </div>
        </div>
      )}
      <img
        src={logo}
        className="absolute -top-10 h-24"
        style={{ left: "50%", transform: "translateX(-50%)" }}
      />
      <img src={line} />
      <div className="container mx-auto mt-14 p-4">
        <p>Don't miss out, get early access to our token whitelist!</p>
        <div className="flex gap-2 justify-center w-full mt-10 text-base md:text-xl">
          <div
            className="bg-[#F1B27A] text-[#934F00] font-bold uppercase px-3 py-2 cursor-pointer"
            onClick={() => {
              register();
            }}
          >
            REGISTER
          </div>
          <input
            onChange={(evt: any) => {
              setEmail(evt.target.value);
            }}
            value={email}
            type="text"
            className="bg-[#FCE8D5] px-3 py-2 text-[#934F00] text-base md:text-xl min-w-0"
            placeholder="YOUR EMAIL ADDRESS"
          />
        </div>
        <p className="opacity-60 mt-4">
          Subscribe our channels to update latest news of Monsterra Events.{" "}
        </p>
        <div className="flex flex-wrap md:flex-nowrap px-0 md:px-10 justify-start md:justify-center  text-left md:text-center">
          <div className="flex flex-col mt-20 md:mr-10 w-1/2 md:w-full">
            <p className="text-white text-xl md:text-2xl font-bold">
              Keep in touch
            </p>
            <a href="https://blogs.monsterra.io/" target="_blank">
              <p className="text-base md:text-lg opacity-60 hover:opacity-100 duration-300  cursor-pointer react-text mt-3">
                News
              </p>
            </a>

            <p
              onClick={() =>
                window
                  .open(
                    "https://whitepaper.monsterra.io/official-channels/support-pages",
                    "_blank"
                  )
                  .focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Support
            </p>
          </div>
          <div className="flex flex-col mt-20 md:mr-10 w-1/2 md:w-full">
            <p className="text-white  text-xl md:text-2xl font-bold ">
              Monsterra World
            </p>
            <p
              onClick={() =>
                window
                  .open(
                    "https://www.youtube.com/channel/UCjTCP6BkSrPS5bDs0JkJBjg",
                    "_blank"
                  )
                  .focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Media
            </p>
            <p
              onClick={() =>
                window.open("https://play.monsterra.io/", "_blank").focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Play Game
            </p>
            <p
              onClick={() =>
                window
                  .open("https://marketplace.monsterra.io/", "_blank")
                  .focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Marketplace
            </p>
          </div>
          <div className="flex flex-col  mt-20 w-1/2 md:w-full">
            <p className="text-white  text-xl md:text-2xl font-bold ">Policy</p>
            <p
              onClick={() =>
                window
                  .open(
                    "https://whitepaper.monsterra.io/policy/term-of-use",
                    "_blank"
                  )
                  .focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Term of Use
            </p>
            <p
              onClick={() =>
                window
                  .open(
                    "https://whitepaper.monsterra.io/policy/disclaimer",
                    "_blank"
                  )
                  .focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Disclaimer
            </p>
            <p
              onClick={() =>
                window
                  .open(
                    "https://whitepaper.monsterra.io/policy/private-policy",
                    "_blank"
                  )
                  .focus()
              }
              className=" text-base md:text-lg opacity-60 hover:opacity-100 duration-300 cursor-pointer react-text mt-3"
            >
              Privacy Policy
            </p>
          </div>
        </div>
        <div className="flex-row mt-11 flex justify-center gap-1">
          {social.map((s: any) => (
            <a href={s.url} target="_blank">
              <img
                className="cursor-pointer react-button h-10 md:h-14 w-10 md:w-14"
                src={s.img}
              />
            </a>
          ))}
        </div>
        <p className="text-[#B6B6B6] mt-4">
          2021 Monsterra, Inc. All rights reserved.
        </p>
      </div>
      <img src={line} className="mt-4" />
    </div>
  );
}
